var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPollIconSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1331 2.5H4.46647C3.5498 2.5 2.7998 3.25 2.7998 4.16667V15.8333C2.7998 16.75 3.5498 17.5 4.46647 17.5H16.1331C17.0498 17.5 17.7998 16.75 17.7998 15.8333V4.16667C17.7998 3.25 17.0498 2.5 16.1331 2.5ZM6.96647 14.1667C6.50814 14.1667 6.13314 13.7917 6.13314 13.3333V9.16667C6.13314 8.70833 6.50814 8.33333 6.96647 8.33333C7.4248 8.33333 7.7998 8.70833 7.7998 9.16667V13.3333C7.7998 13.7917 7.4248 14.1667 6.96647 14.1667ZM10.2998 14.1667C9.84147 14.1667 9.46647 13.7917 9.46647 13.3333V6.66667C9.46647 6.20833 9.84147 5.83333 10.2998 5.83333C10.7581 5.83333 11.1331 6.20833 11.1331 6.66667V13.3333C11.1331 13.7917 10.7581 14.1667 10.2998 14.1667ZM13.6331 14.1667C13.1748 14.1667 12.7998 13.7917 12.7998 13.3333V11.6667C12.7998 11.2083 13.1748 10.8333 13.6331 10.8333C14.0915 10.8333 14.4665 11.2083 14.4665 11.6667V13.3333C14.4665 13.7917 14.0915 14.1667 13.6331 14.1667Z",
    fill: "#065A15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollIconSmall);
export default __webpack_public_path__ + "static/media/poll-icon-small.7dffff6d9a29e061769c576d342662bc.svg";
export { ForwardRef as ReactComponent };